/* ── KOLBO THEME — theme.js ── */

// Countdown timer
function initCountdown() {
  const blocks = document.querySelectorAll('[data-countdown]');
  if (!blocks.length) return;
  const configured = parseInt(document.querySelector('[data-countdown-end]')?.dataset.countdownEnd || 0);

  // Fin del día actual (hora local) como fallback dinámico "solo hoy".
  function endOfToday() {
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return Math.floor(d.getTime() / 1000);
  }

  function update() {
    const now = Math.floor(Date.now() / 1000);
    // Si hay una fecha configurada y aún no pasa, se respeta; si no, reinicio diario.
    const endTime = (configured && configured > now) ? configured : endOfToday();
    let diff = Math.max(0, endTime - now);
    const h = Math.floor(diff / 3600);
    diff -= h * 3600;
    const m = Math.floor(diff / 60);
    const s = diff % 60;
    const hEl = document.querySelector('[data-countdown="hours"]');
    const mEl = document.querySelector('[data-countdown="minutes"]');
    const sEl = document.querySelector('[data-countdown="seconds"]');
    if (hEl) hEl.textContent = String(h).padStart(2, '0');
    if (mEl) mEl.textContent = String(m).padStart(2, '0');
    if (sEl) sEl.textContent = String(s).padStart(2, '0');
  }
  update();
  setInterval(update, 1000);
}

// Cart count update
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badges = document.querySelectorAll('.site-header__cart-count');
      badges.forEach(b => {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(() => {});
}

// Add to cart
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;
  e.preventDefault();
  const variantId = btn.dataset.addToCart;
  if (!variantId) return;
  btn.textContent = 'Agregando…';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = '✓ Agregado';
    updateCartCount();
    setTimeout(() => {
      btn.textContent = 'Agregar al Carrito';
      btn.disabled = false;
    }, 2000);
  })
  .catch(() => {
    btn.textContent = 'Agregar al Carrito';
    btn.disabled = false;
  });
});

// Newsletter form
document.addEventListener('submit', function(e) {
  const form = e.target.closest('.newsletter__form');
  if (!form) return;
  // Shopify handles newsletter via customer subscribe — let form submit naturally
});

document.addEventListener('DOMContentLoaded', function() {
  initCountdown();
  updateCartCount();
});
